import http from '@/lib/http';
import { cmsSavedSectionPath, cmsSavedSectionsPath } from '@/lib/routes';
import type { SavedSection } from '@/types/saved-section';

export interface CreateSavedSectionPayload {
  sectionId: string;
}

export async function fetchSavedSections(): Promise<SavedSection[]> {
  const response = await http.get<unknown>(cmsSavedSectionsPath());
  if (!Array.isArray(response.data)) {
    throw new Error('Unexpected saved sections response shape');
  }
  return response.data as SavedSection[];
}

export async function createSavedSection(
  payload: CreateSavedSectionPayload,
): Promise<SavedSection> {
  const response = await http.post<SavedSection>(cmsSavedSectionsPath(), payload);
  return response.data;
}

export async function deleteSavedSection(id: string): Promise<void> {
  await http.delete(cmsSavedSectionPath(id));
}
